import { useState, useContext, useEffect } from 'react';

import { StatsigGateContext } from 'src/contexts/statsig';
import { StatsigFeatureKeyType } from 'src/features';

// This hook is available as useFeatureGate from the
// `@atlaskit/feature-gate-js-client` package, but it reads from the global
// FeatureGates instance directly. We want to use the value from context so
// that we can override it in tests or other contexts if needed.
export const useStatsigGate = (featureKey: StatsigFeatureKeyType): boolean => {
  const { featureGates } = useContext(StatsigGateContext);
  const [gate, setGate] = useState(() => featureGates.checkGate(featureKey));

  useEffect(() => {
    const onGateChange = (newValue: boolean) => setGate(newValue);
    return featureGates.onGateUpdated(featureKey, onGateChange);
  }, [featureGates, featureKey]);

  return gate;
};
